const _excluded = ["children", "href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useContext, memo } from 'react';
import { Box } from '@cbhq/cds-web/layout';
import { Link } from '@cbhq/cds-web/typography';
import getCoinbaseLocalizedUrl from '../../../utils/getCoinbaseLocalizedUrl.js';
import { GlobalFooterContext } from '../context/GlobalFooterContext.js';
import { jsx } from 'react/jsx-runtime';
function shouldSkipLocalization(path) {
  /*
   * We cannot include this in routesNotToLocalize because
   * this monorail url needs not to be localized, but all
   * its sub-paths are not in monorail and need to be localized.
   */
  return path === '/legal/user_agreement';
}
function CDSFooterLink(_ref) {
  let children = _ref.children,
    href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded);
  const _useContext = useContext(GlobalFooterContext),
    userLocaleInfo = _useContext.userLocaleInfo;
  if (!href) return null;
  const localeCode = userLocaleInfo?.localeCode && userLocaleInfo?.localeCode !== 'en' ? userLocaleInfo?.localeCode : '';
  const skipLocalization = shouldSkipLocalization(href);
  const localizedUrl = !skipLocalization && href ? getCoinbaseLocalizedUrl(href, localeCode) : href;
  return /*#__PURE__*/jsx(Box, {
    as: "li",
    children: /*#__PURE__*/jsx(Link, _objectSpread(_objectSpread({
      to: localizedUrl,
      variant: "body",
      color: "foregroundMuted"
    }, props), {}, {
      children: children
    }))
  });
}
const CDSFooterLink$1 = /*#__PURE__*/memo(CDSFooterLink);
export { CDSFooterLink$1 as default };
//# sourceMappingURL=CDSFooterLink.js.map
